import styled from 'styled-components';
import { palette } from '@seeneco-ui/core/styles';


const Root = styled.div`
	position: relative;
	width: 100%;
	flex: 1 0 auto;
	background-color: ${palette.whitePrimary};
`;

const HeaderLayout = styled.div`
	position: relative;
	background-color: ${palette.whitePrimary};
	padding: 12px 32px;
	border: 1px solid #E7E7E7;
	color: ${palette.blackSecondary};
`;

const ControlsLayout = styled.div`
	display: flex;
	justify-content: flex-end;
	align-items: center;
	padding-top: 10px;

	& > div:not(:last-child) {
		margin-right: 15px;
	}
`;

export {
	Root,
	HeaderLayout,
	ControlsLayout,
};
